import React from 'react'
import moment from 'moment'
import NA from '../not-available'

const OperationalDetail = ({status, status_change_reason, profile_id, hours_per_week, date_of_effect}) => (
  <section>
    <dl className="details-card-list">
      <dt>Status</dt>
      <dd>{status || <NA name="Status" />}</dd>

      <dt>Status change reason</dt>
      <dd>{status_change_reason || <NA name="Reason" />}</dd>

      <dt>Profile ID</dt>
      <dd>{profile_id || <NA name="Profile ID" />}</dd>

      <dt>Hours per week</dt>
      <dd>{hours_per_week || <NA name="Hours" />}</dd>

      <dt>Date of effect</dt>
      <dd>{moment(date_of_effect, 'YYYY-MM-DD').format('dddd Do MMMM YYYY')}</dd>
    </dl>
  </section>
)

export default OperationalDetail


// WEBPACK FOOTER //
// ./src/gov-care-registration-details/views/operational_profile/view.jsx